<div class="modal">
  <div id="header">
    <div class="header-row">
      <div class="title">
        <mat-icon fontSet="material-icons-round" class="close">post_add</mat-icon>
        <span class="kbody-huge">Catalog Suggestions Details</span>
      </div>
      <mat-icon fontSet="material-icons-round" class="close" (click)="closeModal()">close</mat-icon>
    </div>
    <div class="admin-button-row" *ngIf="!isLoading && getCourseItemId()">
      <div class="btn" (click)="openUploadDocumentsModal()">
        <mat-icon fontSet="material-icons-round" class="icon">upload</mat-icon>
        <span class="kbody-medium">Upload Docs</span>
      </div>
    </div>
  </div>
  <div class="modal-content">
    <app-loading-spinner class="spinner" *ngIf="isLoading"></app-loading-spinner>
    <app-catalog-suggestion-review [showStatusRow]="true" *ngIf="!isLoading" [course]="course"></app-catalog-suggestion-review>
  </div>
  <div class="button-row" [ngClass]="{'flex-end': course.currentCatalogStatusKid !== 'SUGGESTION_PENDING'}">
    <app-button *ngIf="course.currentCatalogStatusKid === 'SUGGESTION_PENDING'" [text]="'Deny Suggestion'" [class]="'red'" [icon]="{materialIcon: 'do_disturb_alt'}" (click)="closeModal('deny')"></app-button>
    <div class="actions">
      <app-button *ngIf="course.currentCatalogStatusKid === 'SUGGESTION_PENDING'" [text]="'Approve Request'" [icon]="{materialIcon: 'check'}" (click)="closeModal('approve')" ></app-button>
      <app-button *ngIf="course.currentCatalogStatusKid === 'SUGGESTION_APPROVED'" [class]="'grey'" [text]="'Submit as Catalog Suggestion'"></app-button>
      <app-button [text]="'Cancel'" [class]="'white'" (click)="closeModal()"></app-button>
    </div>
  </div>

  <ng-container *ngIf="!isLoading && showUploadDocumentsModal && getCourseItemId()">
    <app-upload-course-documents 
      [courseItemId]="getCourseItemId()"
      (closeModal)="closeUploadDocumentsModal()"
      (documentsUploaded)="onDocumentsUploaded()">
    </app-upload-course-documents>
  </ng-container>
</div>
